module.exports = __webpack_public_path__ + "static/media/cloudy-day-3.9039acf1.svg";